import { render, staticRenderFns } from "./BaseAddress.vue?vue&type=template&id=38de61ee&scoped=true&"
import script from "./BaseAddress.vue?vue&type=script&lang=js&"
export * from "./BaseAddress.vue?vue&type=script&lang=js&"
import style0 from "./BaseAddress.vue?vue&type=style&index=0&id=38de61ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38de61ee",
  null
  
)

export default component.exports